export const hasValue = (value?: unknown | null) => {
  return value !== undefined && value !== null
}
